<template>
  <div class="ml-4 mr-4 mb-3">
    <div class="row text-primary mb-4" style="font-size: 1rem;">
      <b class="mr-1">Instrucciones: </b> {{instructions}}
    </div>

    <div class="row">
      <p class="text-primary">
        <b>Filas: </b> <input v-model="rowsInput" style="width: 5rem;" class="input" type="number">
        <b> Denominador inicial: </b> <input v-model="denominatorInput" style="width: 5rem;" type="number">
        <button class="btn btn-primary btn-sm ml-2" @click="createStrip"> Crear regleta</button>
      </p>
    </div>

    <div class="row mb-4 text-center">
      <alert
        :type="matchesFound > 1 ? 'success' : 'info'"
        size="lg"
        dismissible
        @dismiss="isShowingMessage = ''"
        :isVisible="isShowingMessage ? true : false"
      >
        {{
          matchesFound > 1 ? 
            `Coincidencias en ${matchesFound} filas`
            : 'Sin coincidencias'
        }}
      </alert>
      <table class="w-100" v-if="matchesFound > 1">
        <thead>
          <tr>
            <td 
              :style="`
                height: 3.5rem;
                font-size: 1rem;
                border-style: solid;
                border-radius: 10px;
              `"
              class="bg-primary" :colspan="matchesFound">
                Estas fracciones coinciden
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              v-for="cell in matchesFractions"
              :style="`
                background-color: ${cell.backgroundColor};
                width: ${100 / matchesFound}%;
                height: 3.5rem;
                font-size: 1rem;
                border-style: solid;
                border-radius: 10px;
              `"
              class="text-white text-center"
              :key="`cellMatchesFractions-${cell.id}`"
            >
              {{cell.label}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div class="row" v-if="currentStrip && !isBuildingStrip">
      <table class="w-100" v-for="(row, index) in currentStrip" :key="`row-${index}`">
        <td
          v-for="cell in row"
          :style="`
            background-color: ${cell.backgroundColor};
            width: ${cell.width};
            height: 3.5rem;
            font-size: 1rem;
            padding-top: 1rem;
            vertical-align: center;
            border-style: solid;
            border-radius: 10px;
            cursor: ${clickable ? 'pointer' : 'not-allowed'};
          `"
          class="text-white text-center"
          :key="`cell-${cell.id}`"
          @click="selectCoincidences(cell)"
        >
          {{cell.label}}
        </td>
      </table>
    </div>

    <div class="row mt-4 mb-4 spinner" v-if="isBuildingStrip">
      <div class="col-sm text-left">
        <div class="loader text-primary"></div>
      </div>
      <div class="col-sm">
      </div>
      <div class="col-sm">
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'fractions-strip',
  props: {
    instructions: {
      type: String,
      default: 'Ingresa un número máximo de filas y un denominador para crear la regleta y buscar coincidencias.'
    },
    rows: {
      type: Number,
      default: 10
    },
    denominator: {
      type: Number,
      default: 1
    },
    autoinit: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: true
    },
  },
  data () {
    return {
      rowsInput: this.rows,
      denominatorInput: this.denominator,
      isBuildingStrip: false,
      colors: [
        "#43AA8B", "#4D908E", "#577590", "#277DA1", "#F94144", "#F3722C", "#F8961E", "#F9844A", "#F9C74F", "#90BE6D",
        "#f72585", "#b5179e", "#7209b7", "#560bad", "#480ca8", "#3a0ca3", "#3f37c9", "#4361ee", "#4895ef", "#4cc9f0",
        "#43AA8B", "#4D908E", "#577590", "#277DA1", "#F94144", "#F3722C", "#F8961E", "#F9844A", "#F9C74F", "#90BE6D",
      ],
      currentStrip: [],
      matchesFound: 0,
      matchesFractions: [],
      isShowingMessage: false
    }
  },
  watch: {
    rowsInput () {
      if (this.rowsInput <= 2) this.rowsInput = 2;
      if (this.rowsInput > 30) this.rowsInput = 30;
    },
    denominatorInput () {
      if (this.denominatorInput <= 1) this.denominatorInput = 1;
      if (this.denominatorInput > 30) this.denominatorInput = 30;
    }
  },
  created () {
    if (this.autoinit) this.createStrip();
    else this.currentStrip.push(
      [
        {
          backgroundColor: this.colors[0],
          id: '1:1',
          label: '1',
          width: '100%',
          value: 1
        },
      ]
    )
  },
  methods: {
    clearMatches() {
      this.matchesFound = 0;
      this.matchesFractions = [];
      this.isShowingMessage = false;
    },
    createStrip(){
      this.isBuildingStrip = true;
      this.clearMatches();
      setTimeout(() => {
        this.buildStrip();
        this.isBuildingStrip = false;
      }, 1000);
    },
    buildStrip() {
      let firstDenominator = parseInt(this.denominatorInput);
      let maxRows = parseInt(this.rowsInput);
      let strip = Array(maxRows).fill([]);

      this.currentStrip = strip.map((row, index) => {
        let fraction = 0;

        if (firstDenominator == 1 || index == 0) fraction = index + 1;
        //else fraction = Math.pow(firstDenominator, index);
        else fraction = firstDenominator * index;

        if (fraction > 30) return false;
        
        let colorIndex = index;
        if (colorIndex > this.colors.length) {
          colorIndex = colorIndex % this.colors.length;
        }

        const color = this.colors[colorIndex];
        const width = 100 / fraction;

        let cells = Array(fraction).fill({
          backgroundColor: color,
          label: fraction == 1 ? fraction : `1/${fraction}`,
          width: width + "%",
          value: parseInt(fraction),
          id: '',
          quotient: 0
        });
        
        row = cells.map((cell, cellIndex) => ({
          ...cell,
          id: fraction + ":" + parseInt(cellIndex + 1),
          quotient: parseInt(cellIndex + 1) / fraction
        }));

        return row;
      }).filter(row => row);
    },
    selectCoincidences(selectedCell) {
      if (selectedCell.id == '1:1') return;
      if (!this.clickable) return;
      this.clearMatches();
      this.buildStrip();
      
      this.currentStrip = this.currentStrip.map(row => {

        let isEqualInRow = row.some(cell => cell.quotient == selectedCell.quotient);
        if (isEqualInRow) this.matchesFound++;

        row = row.map((cell, index) => {

          if (!isEqualInRow) cell.backgroundColor = "black";
          else if (isEqualInRow && (cell.quotient > selectedCell.quotient)) {
            cell.backgroundColor = "black";
          } else if (isEqualInRow && (cell.quotient == selectedCell.quotient)) {
            this.matchesFractions.push({
              id: cell.value,
              backgroundColor: cell.backgroundColor,
              label: `${index + 1}/${cell.value}`
            });
          }

          return cell;
        });

        return row;
      });

      this.isShowingMessage = true;
    }
  }
}
</script>
